export default __webpack_public_path__ + "static/media/cellarTop.e84cf142.png";